export default __webpack_public_path__ + "assets/australia-flag.png";